// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"128":"a234dc68a8f16bb9","911":"a5207e728460d93e"}[chunkId] + ".js";
};